module.exports = __webpack_public_path__ + "img/recycle.15fb7c68.png";